module.exports = __webpack_public_path__ + "static/media/50011.3deb0090.png";